import { createSlice } from "@reduxjs/toolkit";
import { loginUser, logoutUser } from "../actions/auth";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    user: null,
    token: null,
    isAdmin: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      //login user
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        const { result: user, tokens } = action.payload;

        state.user = user;
        state.token = tokens;
        state.isAdmin = parseInt(user.roleId, 10) === 0;

        // Store user and token in localStorage
        localStorage.setItem("token", tokens);
        localStorage.setItem("user", JSON.stringify(user));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // The error message from `rejectWithValue`
      })
      //logout user
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = null;
        state.token = null;
        state.isAdmin = false;
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        state.error = action.payload;
      });
  },
});
export default authSlice.reducer;
